import React										from 'react';

import Icon											from '../Icon';

import {Device}										from '../../../redux/devices/interface';
import {ImageFormat}								from '../../typescript-declaration/global';
import {Catalog, CatalogMinimal,
	CatalogSortCategories}							from '../../../redux/catalog/interface';

import {ft_getCatalogDeviceImage,
	ft_getDeviceImage,
	ft_getDeviceImageByString,
	ft_getDeviceType}								from '../../functions/deviceFunction';
import ft_cssVar									from '../../functions/getCssVar';

import './DeviceComponent.css';


interface DeviceImageProps {
	device?: Device,
	catalog?: Catalog | CatalogMinimal | CatalogSortCategories | Record<string, never>,
	forceIndex?: number,
	className?: string,
	imageFormat?: ImageFormat,
	size?: number,
	iconSize?: number,
	style?: React.CSSProperties,
	forceType?: string,
	onClick?: () => void
}

function DeviceImage(props: DeviceImageProps): React.ReactElement {
	const style: React.CSSProperties = {
		maxHeight: props.size,
		minHeight: props.size,
		maxWidth:  props.size,
		minWidth:  props.size,
		...props.style
	};

	if (!props.className) {
		style.backgroundPosition = 'center';
		style.backgroundSize = 'contain';
		style.backgroundRepeat = 'no-repeat';
	}

	if (props.catalog)
		style.backgroundImage = `url('${ft_getCatalogDeviceImage(props.catalog, props.imageFormat, props.forceIndex)}')`;
	else if (props.device && !props.device?.notValala)
		style.backgroundImage = `url('${ft_getDeviceImage(props.device, props.imageFormat, props.forceIndex)}')`;

	if (style.backgroundImage)
		return <div className={props.className} style={style} onClick={props.onClick} />;

	return (
		<Icon
			iconBorder
			borderSize={0}
			onClick={props.onClick}
			size={props.size || 48}
			iconSize={props.iconSize || 20}
			iconColor={ft_cssVar('primary-600')}
			icon={
				props.forceType ?
					ft_getDeviceImageByString(ft_getDeviceType(undefined, props.forceType))
					:
					ft_getDeviceImage(props.device) || ''
			}
		/>
	);
}

export default DeviceImage;
